import MODAL_MODE from '../../../pages/data/common/constants';
import {
  Qualification,
  QualificationUserRelation,
} from '../../../pages/data/organization/tracked-items/types';

const actions = {
  OPEN_MODAL: 'pages/qualifications/OPEN_MODAL',
  CLOSE_MODAL: 'pages/qualifications/CLOSE_MODAL',
  SET_QUALIFICATIONS: 'pages/qualifications/SET_QUALIFICATIONS',
  SET_ARCHIVED_QUALIFICATIONS: 'pages/qualifications/SET_ARCHIVED_QUALIFICATIONS',
  SET_FILTER_QUALIFICATIONS: 'pages/qualifications/SET_FILTER_QUALIFICATIONS',
  SET_QUALIFICATION_USER_RELATIONS: 'pages/qualifications/SET_QUALIFICATION_USER_RELATIONS',
  SET_FILTER_NAME: 'pages/qualifications/SET_FILTER_NAME',
  SET_QUALIFICATIONS_STRUCTURE: 'pages/qualifications/SET_QUALIFICATIONS_STRUCTURE',
  SET_EXPANDED_QUALIFICATION_ID: 'pages/qualifications/SET_EXPANDED_QUALIFICATION_ID',
  SET_TRACKED_ITEMS_BY_QUAL: 'pages/qualifications/SET_TRACKED_ITEMS_BY_QUAL',
  SET_CERT_GROUPS_BY_QUAL: 'pages/qualifications/SET_CERT_GROUPS_BY_QUAL',
};

export interface OpenQualificationModalAction {
  type: typeof actions.OPEN_MODAL;
  payload: { mode: MODAL_MODE };
}

export interface CloseQualificationModalAction {
  type: typeof actions.CLOSE_MODAL;
}

export interface SetQualificationsAction {
  type: typeof actions.SET_QUALIFICATIONS;
  payload: { qualifications: Qualification[] };
}

export interface SetArchivedQualificationsAction {
  type: typeof actions.SET_ARCHIVED_QUALIFICATIONS;
  payload: { archivedQualifications: Qualification[] };
}

export interface SetFilterQualificationsAction {
  type: typeof actions.SET_FILTER_QUALIFICATIONS;
  payload: { filterQualifications: Qualification[] };
}

export interface SetQualificationUserRelationsAction {
  type: typeof actions.SET_QUALIFICATION_USER_RELATIONS;
  payload: { qualificationUserRelations: QualificationUserRelation[] };
}

export interface SetFilterNameAction {
  type: typeof actions.SET_FILTER_NAME;
  payload: { filterName: string };
}

export const setExpandedQualificationId = (expandedQualificationId: string) => ({
  type: actions.SET_EXPANDED_QUALIFICATION_ID,
  payload: { expandedQualificationId },
});

export const openQualificationModalAction = (mode: MODAL_MODE): OpenQualificationModalAction => ({
  type: actions.OPEN_MODAL,
  payload: { mode },
});

export const closeQualificationModalAction = (): CloseQualificationModalAction => ({
  type: actions.CLOSE_MODAL,
});

export const setQualificationsAction = (
  qualifications: Qualification[],
): SetQualificationsAction => ({
  type: actions.SET_QUALIFICATIONS,
  payload: { qualifications },
});

export const setArchivedQualificationsAction = (
  archivedQualifications: Qualification[],
): SetArchivedQualificationsAction => ({
  type: actions.SET_ARCHIVED_QUALIFICATIONS,
  payload: { archivedQualifications },
});

export const setFilterQualificationsAction = (
  filterQualifications: Qualification[],
): SetFilterQualificationsAction => ({
  type: actions.SET_FILTER_QUALIFICATIONS,
  payload: { filterQualifications },
});

export const setQualificationUserRelationAction = (
  qualificationUserRelations: QualificationUserRelation[],
): SetQualificationUserRelationsAction => ({
  type: actions.SET_QUALIFICATION_USER_RELATIONS,
  payload: { qualificationUserRelations },
});

export const setFilterNameAction = (filterName: string): SetFilterNameAction => ({
  type: actions.SET_FILTER_NAME,
  payload: { filterName },
});

export const setQualificationsStructure = (qualificationStructure: Record<string, any[]>) => ({
  type: actions.SET_QUALIFICATIONS_STRUCTURE,
  payload: { qualificationStructure },
});

export const setTrackedItemsByQual = (trackedItemsByQual: Record<string, any[]>) => ({
  type: actions.SET_TRACKED_ITEMS_BY_QUAL,
  payload: { trackedItemsByQual },
});

export const setCertGroupsByQual = (certGroupsByQual: Record<string, any[]>) => ({
  type: actions.SET_CERT_GROUPS_BY_QUAL,
  payload: { certGroupsByQual },
});

export default actions;
